import * as React from "react";
import LinkComponent from "./LinkComponent";
import {connect} from "react-redux";
import {currentPathSelector} from "../../_helpers/routerSelectors";
import {ChildrenType} from "../../_definitions/styleteq";
import * as _ from 'lodash';

interface Props {
    to: string;
    onClick?: any;
    children: ChildrenType;
    exact?: boolean;
}

const mapStateToProps = (state, props: Props) => {
    const currentPath = currentPathSelector(state);

    return {
        active: props.exact ? _.eq(currentPath, props.to) : _.startsWith(currentPath, props.to)
    }
};

const LinkContainer = connect<any, any, Props>(mapStateToProps)(LinkComponent);
export default LinkContainer;


// WEBPACK FOOTER //
// ./app/client/_widgets/sidebarLink/LinkContainer.tsx